(() => {
  if (window.hsMountSwitchInstalled) return;
  window.hsMountSwitchInstalled = true;
  let busy = false;
  let observer;
  let applying = false;
  const main = () => document.getElementById('MainContent');
  const controls = () => main()?.querySelector('[data-hs-mount-switch]');
  const options = () => {
    const picker = main()?.querySelector('variant-radios,variant-selects');
    if (!picker) return [];
    return picker.matches('variant-radios') ? Array.from(picker.querySelectorAll('fieldset'), field => field.querySelector('input:checked')?.value) : Array.from(picker.querySelectorAll('select'), select => select.value);
  };
  const syncTabs = () => {
    const header = document.querySelector('.header-wrapper');
    const height = header?.classList.contains('apex-header-sticky') && !header.classList.contains('apex-header-hidden') ? header.offsetHeight : 0;
    if (controls()) main().querySelectorAll('.apex-tabs__nav-sticky').forEach(nav => nav.style.top = `${height}px`);
    return height;
  };
  const gallery = () => {
    if (!controls() || applying) return;
    applying = true;
    const id = main().querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
    main().querySelectorAll('.hs-variant-extra-slide').forEach(slide => {
      const active = slide.dataset.hsVariantId === String(id);
      if (slide.classList.contains('is-active') !== active) slide.classList.toggle('is-active',active);
      if (active && slide.style.display === 'none') slide.style.removeProperty('display');
      if (!active && slide.style.display !== 'none') slide.style.display = 'none';
    });
    main().querySelectorAll('slider-component').forEach(slider => slider.initPages?.());
    applying = false;
  };
  const refreshCouponDates = () => {
    main()?.querySelectorAll('[data-hs-coupon-days]').forEach(coupon => {
      const days = Number(coupon.dataset.hsCouponDays);
      const target = coupon.querySelector('#dev-date-ends-1,#dev-date-ends-2');
      if (!target || !Number.isFinite(days)) return;
      const end = new Date();
      end.setDate(end.getDate() + days);
      const month = String(end.getMonth() + 1).padStart(2,'0');
      const day = String(end.getDate()).padStart(2,'0');
      target.textContent = coupon.dataset.hsCouponFormat === 'mm_dd_yyyy' ? `${month}/${day}/${end.getFullYear()}` : `${day}/${month}/${end.getFullYear()}`;
    });
  };
  const initialize = () => {
    refreshCouponDates();
    observer?.disconnect();
    if (!controls()) return;
    gallery();syncTabs();
    observer = new MutationObserver(gallery);
    main().querySelectorAll('.product__media-list').forEach(list => observer.observe(list,{attributes:true,attributeFilter:['class','style'],subtree:true}));
  };
  const choose = (variants, selected) => {
    const available = variants.filter(v => v.available);
    const score = v => v.options.reduce((sum,value,i) => sum + (value === selected[i] ? [4,2,1][i] || 1 : 0),0);
    return (available.length ? available : variants).reduce((best,v) => !best || score(v) > score(best) ? v : best,null);
  };
  async function switchMount(link) {
    if (busy) return;
    const control = controls();
    const selected = options();
    const variantData = link.closest('[data-hs-product-choice]')?.querySelector('[data-hs-sibling-variants]') || control.querySelector('[data-hs-sibling-variants]');
    const variant = choose(JSON.parse(variantData.textContent),selected);
    if (!variant) {window.location.assign(link.href);return;}
    busy = true;
    const url = new URL(link.href,location.href);
    const current = new URL(location.href);
    if (current.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id',current.searchParams.get('preview_theme_id'));
    url.searchParams.set('variant',variant.id);
    const position = control.getBoundingClientRect().top;
    control.querySelector('[role="status"]').textContent = control.dataset.loading;
    main().setAttribute('aria-busy','true');
    control.querySelectorAll('a').forEach(a => a.setAttribute('aria-disabled','true'));
    main().querySelectorAll('button[name="add"]').forEach(button => button.disabled = true);
    try {
      const response = await fetch(url,{credentials:'same-origin'});
      if (!response.ok) throw new Error('Mount request failed');
      const html = new DOMParser().parseFromString(await response.text(),'text/html');
      const incoming = html.getElementById('MainContent');
      const id = incoming?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
      if (!incoming?.querySelector('[data-hs-mount-switch]') || String(id) !== String(variant.id)) throw new Error('Mount configuration missing');
      observer?.disconnect();window.pauseAllMedia?.();
      document.querySelectorAll('product-modal[id^="ProductModal-"],modal-dialog[id^="PopupModal-"]').forEach(modal => modal.remove());
      main().replaceWith(document.importNode(incoming,true));
      document.title = html.title;
      history.pushState({},'',url);
      const canonical = document.querySelector('link[rel="canonical"]');
      const nextCanonical = html.querySelector('link[rel="canonical"]');
      if (canonical && nextCanonical) canonical.href = nextCanonical.href;
      const nextLinks = html.querySelectorAll('localization-form a[href]');
      document.querySelectorAll('localization-form a[href]').forEach((a,i) => {if(nextLinks[i])a.href=nextLinks[i].href;});
      initialize();
      const newControl = controls();
      newControl.querySelector('[role="status"]').textContent = variant.options.some((value,i) => value !== selected[i]) ? newControl.dataset.adjusted : newControl.dataset.ready;
      const active = newControl.querySelector('[aria-current]');
      active.setAttribute('tabindex','-1');active.focus({preventScroll:true});
      window.scrollBy(0,newControl.getBoundingClientRect().top-position);
      window.yotpoWidgetsContainer?.initWidgets?.();
      window.yotpo?.initWidgets?.();
      window.Shopify?.PaymentButton?.init?.();
      document.dispatchEvent(new CustomEvent('hs:mount:change',{detail:{variantId:variant.id,productUrl:url.pathname}}));
    } catch (error) {
      window.location.assign(url);
    } finally {busy=false;main()?.removeAttribute('aria-busy');}
  }
  document.addEventListener('click',event => {
    const link = event.target.closest('[data-hs-mount-link]');
    if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {event.preventDefault();switchMount(link);return;}
    if (!controls()) return;
    const button = event.target.closest('.apex-tabs__button');
    if (button) {
      const container = button.closest('.apex-tabs');
      const panel = container.querySelector(`#apex-tab-${button.dataset.tab}`);
      if (!panel) return;
      container.querySelectorAll('.apex-tabs__button').forEach(item => {item.classList.toggle('apex-tabs__button--active',item===button);item.setAttribute('aria-selected',String(item===button));});
      container.querySelectorAll('.apex-tabs__panel').forEach(item => item.classList.toggle('apex-tabs__panel--active',item===panel));
      requestAnimationFrame(() => {
        const height = syncTabs()+(container.querySelector('.apex-tabs__nav-sticky')?.offsetHeight||0);
        window.apexProgrammaticScroll=true;
        window.scrollTo({top:panel.getBoundingClientRect().top+window.scrollY-height,behavior:'instant'});
        setTimeout(() => {window.apexProgrammaticScroll=false;syncTabs();},50);
      });
    }
    const detail = event.target.closest('.hs-size-btn,.hs-mat-btn');
    if (detail) {
      const size=detail.matches('.hs-size-btn');const prefix=size?'hs-size':'hs-mat';
      const block=detail.closest(size?'.hs-dims-block':'.apex-specs__block');
      const target=size?detail.dataset.hsSizeTarget:detail.dataset.hsMatTarget;
      block?.querySelectorAll(`.${prefix}-btn`).forEach(item => {item.classList.toggle(`${prefix}-btn--active`,item===detail);item.setAttribute('aria-selected',String(item===detail));});
      block?.querySelectorAll(`.${prefix}-panel`).forEach(item => item.classList.toggle(`${prefix}-panel--active`,item.id===target));
    }
  });
  document.addEventListener('change',event => {if(event.target.closest('[data-hs-normalize]'))setTimeout(gallery,0);});
  window.addEventListener('popstate',() => {if(controls())location.reload();});
  window.addEventListener('scroll',syncTabs,{passive:true});
  const header=document.querySelector('.header-wrapper');
  if(header)new MutationObserver(syncTabs).observe(header,{attributes:true,attributeFilter:['class']});
  if(typeof subscribe==='function')subscribe(PUB_SUB_EVENTS.variantChange,event => {
    if(!controls())return;const variant=event.data.variant;
    main().querySelectorAll('.hs-current-sku').forEach(el => el.textContent=variant.sku);
    main().querySelectorAll('.hs-current-option').forEach(el => el.textContent=variant.options[Number(el.dataset.hsOption)]);
    gallery();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
})();
